export const libraryData = [
  {
    id: 1,
    title: '글로벌 리더십의 핵심 원칙',
    description: '다국적 팀을 이끄는 리더들의 실전 경험과 인사이트',
    author: '김민준',
    role: 'Global VP, Tech Company',
    category: '리더십',
    isPremium: true,
    image: 'https://public.readdy.ai/ai/img_res/590c9c596668b3e9ee1e0e3c55f01139.jpg',
  },
  {
    id: 2,
    title: '디지털 전환 시대의 커리어 전략',
    description: 'AI와 자동화 시대에 필요한 핵심 역량과 준비 방법',
    author: '이서연',
    role: 'Digital Transformation Lead',
    category: '커리어 전략',
    isPremium: true,
    image: 'https://readdy.ai/api/search-image?query=digital%20transformation%20and%20technology%20innovation%20in%20modern%20business%20office%20with%20clean%20contemporary%20design%20and%20futuristic%20corporate%20atmosphere&width=600&height=400&seq=library002&orientation=landscape',
  },
  {
    id: 3,
    title: '글로벌 네트워킹의 기술',
    description: '국제 비즈니스 관계 구축과 유지의 실전 노하우',
    author: '박지훈',
    role: 'Business Development Director',
    category: '네트워킹',
    isPremium: false,
    image: 'https://readdy.ai/api/search-image?query=international%20business%20networking%20event%20with%20professionals%20connecting%20in%20elegant%20modern%20venue%20featuring%20sophisticated%20corporate%20atmosphere%20and%20clean%20contemporary%20design&width=800&height=500&seq=library003&orientation=landscape',
  },
  {
    id: 4,
    title: '외국계 기업의 성과 평가 시스템 이해하기',
    description: '글로벌 기업의 평가 기준과 성공적인 커리어 관리 전략',
    author: '최유진',
    role: 'HR Strategy Consultant',
    category: '커리어 관리',
    isPremium: false,
    image: 'https://readdy.ai/api/search-image?query=business%20performance%20evaluation%20and%20career%20development%20in%20modern%20corporate%20office%20with%20professional%20meeting%20setup%20and%20clean%20contemporary%20design&width=900&height=400&seq=library004&orientation=landscape',
  },
  {
    id: 5,
    title: '크로스컬처 커뮤니케이션 마스터하기',
    description: '문화적 차이를 이해하고 효과적으로 소통하는 방법',
    author: '정현우',
    role: 'International Relations Manager',
    category: '커뮤니케이션',
    isPremium: true,
    image: 'https://readdy.ai/api/search-image?query=cross%20cultural%20business%20communication%20with%20diverse%20international%20team%20in%20modern%20office%20featuring%20clean%20design%20and%20professional%20corporate%20environment&width=600&height=350&seq=library005&orientation=landscape',
  },
  {
    id: 6,
    title: '스타트업에서 대기업으로의 전환',
    description: '다양한 조직 문화 경험을 커리어 자산으로 만드는 법',
    author: '강수민',
    role: 'Career Transition Coach',
    category: '커리어 전환',
    isPremium: true,
    image: 'https://readdy.ai/api/search-image?query=startup%20to%20corporate%20career%20transition%20concept%20with%20modern%20business%20professional%20in%20contemporary%20office%20space%20featuring%20clean%20minimalist%20design&width=600&height=350&seq=library006&orientation=landscape',
  },
];
